/* Spectra Cart Drawer Enhancements — B-113 + B-114
   - Free-shipping progress bar
   - 2-product upsell row
   - Adds via XHR + FormData with sections param, then hands the response to
     the existing cart-drawer custom element's renderContents() method (Dawn API)
   - Re-renders our shipping bar / upsell over the freshly rendered drawer DOM
*/
(function () {
  var THRESHOLD = (window.SP_SHIP_THRESHOLD_CENTS != null) ? window.SP_SHIP_THRESHOLD_CENTS : 15000;
  var UPSELL_HANDLES = window.SP_UPSELL_HANDLES || ['breast-pump-valve', 'backflow-filter-premium'];

  var styleInjected = false;
  var upsellCache = {};
  var lastRender = 0;
  var rendering = false;

  function log() {
    if (window.SP_CART_DEBUG) {
      try { console.log.apply(console, ['[sp-cart]'].concat([].slice.call(arguments))); } catch (e) {}
    }
  }

  // ─── Styles ─────────────────────────────────────────────────────────────────
  function injectStyles() {
    if (styleInjected) return;
    styleInjected = true;
    var css = [
      '.sp-ship-bar{padding:14px 20px 16px;background:#F8F5F1;border-bottom:1px solid #EDE6DD;font-family:inherit}',
      '.sp-ship-bar__message{font-size:13px;color:#1C1A17;line-height:1.4;margin:0 0 10px;text-align:center}',
      '.sp-ship-bar__amount{color:#C06880;font-weight:600}',
      '.sp-ship-bar__track{height:6px;background:#EDE6DD;border-radius:999px;overflow:hidden}',
      '.sp-ship-bar__fill{height:100%;background:#C06880;border-radius:999px;transition:width .4s ease}',
      '.sp-ship-bar--unlocked .sp-ship-bar__fill{background:#6FA878}',
      '.sp-ship-bar--unlocked .sp-ship-bar__amount{color:#6FA878}',
      '.sp-upsell{padding:16px 20px;background:#FFFFFF;border-top:1px solid #EDE6DD}',
      '.sp-upsell__heading{font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#8A7E72;margin:0 0 12px;font-weight:600}',
      '.sp-upsell__list{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:10px}',
      '.sp-upsell__item{display:flex;align-items:center;gap:12px}',
      '.sp-upsell__image{width:48px;height:48px;object-fit:cover;border-radius:6px;background:#F8F5F1;flex-shrink:0}',
      '.sp-upsell__body{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}',
      '.sp-upsell__title{font-size:13px;color:#1C1A17;text-decoration:none;line-height:1.3;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
      '.sp-upsell__title:hover{color:#C06880}',
      '.sp-upsell__price{font-size:12px;color:#8A7E72}',
      '.sp-upsell__add{background:#FFFFFF;color:#C06880;border:1px solid #C06880;border-radius:6px;padding:8px 16px;font-size:12px;font-weight:600;cursor:pointer;letter-spacing:.02em;transition:background .15s}',
      '.sp-upsell__add:hover{background:#C06880;color:#FFFFFF}',
      '.sp-upsell__add:disabled{opacity:.5;cursor:not-allowed}'
    ].join('');
    var s = document.createElement('style');
    s.textContent = css;
    document.head.appendChild(s);
  }

  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderShippingBar(cart) {
    var remaining = THRESHOLD - cart.total_price;
    if (remaining < 0) remaining = 0;
    var pct = Math.min(100, Math.round((cart.total_price * 100) / THRESHOLD));
    var unlocked = remaining === 0;
    var msg = unlocked
      ? '<span class="sp-ship-bar__amount">Free express shipping unlocked 🎉</span>'
      : 'You\u2019re <span class="sp-ship-bar__amount">' + formatMoney(remaining) + '</span> away from free express shipping';
    return (
      '<div class="sp-ship-bar' + (unlocked ? ' sp-ship-bar--unlocked' : '') + '">' +
        '<p class="sp-ship-bar__message">' + msg + '</p>' +
        '<div class="sp-ship-bar__track" role="progressbar" aria-valuenow="' + pct + '" aria-valuemin="0" aria-valuemax="100">' +
          '<div class="sp-ship-bar__fill" style="width:' + pct + '%"></div>' +
        '</div>' +
      '</div>'
    );
  }

  // ─── XHR helpers ────────────────────────────────────────────────────────────
  function xhrGet(url) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('GET', url);
      x.setRequestHeader('Accept', 'application/json');
      x.onload = function () {
        if (x.status >= 200 && x.status < 300) {
          try { resolve(JSON.parse(x.responseText)); }
          catch (e) { resolve(x.responseText); }
        } else { reject(new Error('GET ' + url + ' -> ' + x.status)); }
      };
      x.onerror = function () { reject(new Error('GET ' + url + ' network error')); };
      x.send();
    });
  }

  // POST FormData (multipart) — required for Shopify cart-add with sections param
  function xhrPostForm(url, formData) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', url);
      x.setRequestHeader('Accept', 'application/json');
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      // Do NOT set Content-Type — browser will set it with multipart boundary
      x.onload = function () {
        if (x.status >= 200 && x.status < 300) {
          try { resolve(JSON.parse(x.responseText)); }
          catch (e) { resolve(x.responseText); }
        } else {
          var err = new Error('POST ' + url + ' -> ' + x.status);
          err.response = x.responseText;
          reject(err);
        }
      };
      x.onerror = function () { reject(new Error('POST ' + url + ' network error')); };
      x.send(formData);
    });
  }

  // ─── Upsell ─────────────────────────────────────────────────────────────────
  function fetchProduct(handle) {
    if (upsellCache[handle] !== undefined) return Promise.resolve(upsellCache[handle]);
    return xhrGet('/products/' + handle + '.js').then(function (p) {
      upsellCache[handle] = p; return p;
    }).catch(function () { upsellCache[handle] = null; return null; });
  }

  function renderUpsellItem(product) {
    if (!product || !product.available) return '';
    var variant = product.variants && product.variants[0];
    if (!variant) return '';
    var img = product.featured_image || (product.images && product.images[0]) || '';
    return (
      '<li class="sp-upsell__item" data-handle="' + product.handle + '">' +
        (img ? '<img class="sp-upsell__image" src="' + img + '&width=120" alt="" loading="lazy">' : '<div class="sp-upsell__image"></div>') +
        '<div class="sp-upsell__body">' +
          '<a href="' + product.url + '" class="sp-upsell__title">' + escapeHtml(product.title) + '</a>' +
          '<span class="sp-upsell__price">' + formatMoney(variant.price) + '</span>' +
        '</div>' +
        '<button type="button" class="sp-upsell__add" data-variant-id="' + variant.id + '" aria-label="Add to cart">Add</button>' +
      '</li>'
    );
  }

  function getCartVariantIds(cart) {
    var ids = {};
    (cart.items || []).forEach(function (i) { ids[i.variant_id] = true; });
    return ids;
  }

  function renderUpsell(cart) {
    var inCart = getCartVariantIds(cart);
    return Promise.all(UPSELL_HANDLES.map(fetchProduct)).then(function (products) {
      var items = products
        .filter(function (p) { return p && p.available; })
        .filter(function (p) { return !inCart[p.variants[0].id]; })
        .map(renderUpsellItem)
        .join('');
      if (!items) return '';
      return '<div class="sp-upsell"><p class="sp-upsell__heading">Add to your order</p><ul class="sp-upsell__list">' + items + '</ul></div>';
    });
  }

  // ─── Slot management ────────────────────────────────────────────────────────
  function getCartDrawer() { return document.querySelector('#CartDrawer'); }

  function ensureSlot(id, refEl, position) {
    var existing = document.getElementById(id);
    if (existing) return existing;
    var slot = document.createElement('div');
    slot.id = id;
    if (position === 'before') {
      refEl.parentNode.insertBefore(slot, refEl);
    } else {
      refEl.parentNode.insertBefore(slot, refEl.nextSibling);
    }
    return slot;
  }

  function removeSlot(id) {
    var el = document.getElementById(id);
    if (el) el.parentNode.removeChild(el);
  }

  function render() {
    var now = Date.now();
    if (now - lastRender < 150) return;
    if (rendering) return;
    rendering = true;
    lastRender = now;

    var drawer = getCartDrawer();
    if (!drawer) { rendering = false; return; }

    xhrGet('/cart.js').then(function (cart) {
      log('cart fetched', cart.item_count, 'items, total', cart.total_price);

      injectStyles();

      if (!cart || !cart.items || cart.items.length === 0) {
        removeSlot('sp-ship-bar-slot');
        removeSlot('sp-upsell-slot');
        rendering = false;
        return;
      }

      var itemsWrap = drawer.querySelector('cart-drawer-items');
      if (itemsWrap) {
        var shipSlot = ensureSlot('sp-ship-bar-slot', itemsWrap, 'before');
        shipSlot.innerHTML = renderShippingBar(cart);
      }

      var footer = drawer.querySelector('.drawer__footer');
      if (footer) {
        var upsellSlot = ensureSlot('sp-upsell-slot', footer, 'before');
        renderUpsell(cart).then(function (html) { upsellSlot.innerHTML = html; });
      }

      rendering = false;
    }).catch(function (e) { log('render error', e); rendering = false; });
  }

  // ─── Add-to-cart via Dawn-style FormData with sections ──────────────────────
  // This is the Shopify-recommended pattern: post to /cart/add.js with a FormData
  // body containing `sections=cart-drawer,cart-icon-bubble` so the response
  // includes the rendered section HTML. Then hand that to Shopify's
  // cart-drawer custom element via its renderContents() method.
  function addAndRefresh(variantId) {
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');

    var cartDrawerEl = document.querySelector('cart-drawer');
    var sectionsToRefresh = [];

    // Ask Dawn's cart-drawer for the sections it knows how to render
    if (cartDrawerEl && typeof cartDrawerEl.getSectionsToRender === 'function') {
      try {
        sectionsToRefresh = cartDrawerEl.getSectionsToRender().map(function (s) { return s.section || s.id; });
      } catch (e) { log('getSectionsToRender failed', e); }
    }
    if (!sectionsToRefresh.length) {
      sectionsToRefresh = ['cart-drawer', 'cart-icon-bubble'];
    }
    sectionsToRefresh.forEach(function (sid) { fd.append('sections[]', sid); });
    fd.append('sections_url', window.location.pathname);

    log('POST /cart/add.js', { id: variantId, sections: sectionsToRefresh });

    return xhrPostForm('/cart/add.js', fd).then(function (resp) {
      log('add response', resp);

      // Hand off to the cart-drawer custom element's own render method.
      // Dawn's cart-drawer.js exposes renderContents(parsedState) which
      // updates the line items, totals, and checkout button correctly.
      if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function' && resp && resp.sections) {
        try {
          cartDrawerEl.renderContents(resp);
          log('renderContents called');
        } catch (e) {
          log('renderContents threw', e);
          fallbackReplace(resp);
        }
      } else if (resp && resp.sections) {
        fallbackReplace(resp);
      } else {
        log('no sections in response, doing full reload');
        location.reload();
        return;
      }

      // Open the drawer so the new state is visible
      try {
        if (cartDrawerEl && typeof cartDrawerEl.open === 'function') cartDrawerEl.open();
      } catch (e) {}

      // Re-render our enhancements over the fresh DOM
      setTimeout(render, 50);

      return resp;
    });
  }

  // Fallback: parse the section HTML and swap nodes manually.
  // Only used if cart-drawer.renderContents() doesn't exist on this theme.
  function fallbackReplace(resp) {
    var sections = resp.sections || {};
    var html = sections['cart-drawer'];
    if (!html) { log('fallback: no cart-drawer html'); return; }
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    // The section HTML wraps the cart-drawer custom element. Find the inner
    // .drawer__inner and replace ours with it — that's what Dawn replaces.
    var newInner = doc.querySelector('.drawer__inner');
    var oldInner = document.querySelector('cart-drawer .drawer__inner');
    if (newInner && oldInner) {
      oldInner.innerHTML = newInner.innerHTML;
      log('fallback: replaced .drawer__inner');
    } else {
      log('fallback: could not find .drawer__inner');
    }

    // Cart icon bubble
    var bubbleHtml = sections['cart-icon-bubble'];
    if (bubbleHtml) {
      var bw = document.createElement('div');
      bw.innerHTML = bubbleHtml;
      var newBubble = bw.querySelector('#cart-icon-bubble');
      var oldBubble = document.querySelector('#cart-icon-bubble');
      if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
    }
  }

  // ─── Click handler ──────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.sp-upsell__add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;

    btn.disabled = true;
    var originalLabel = btn.textContent;
    btn.textContent = 'Adding...';

    addAndRefresh(parseInt(vid, 10))
      .then(function () {
        btn.textContent = originalLabel;
        btn.disabled = false;
      })
      .catch(function (err) {
        log('add failed', err, err && err.response);
        btn.disabled = false;
        btn.textContent = originalLabel;
        alert('Sorry, could not add that to your cart. Please try again.');
      });
  });

  // ─── Install + observe ──────────────────────────────────────────────────────
  function install() {
    render();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) { setTimeout(install, 500); return; }

    // Watch for cart drawer DOM changes (e.g. when Dawn re-renders after an add)
    // and re-inject our shipping bar / upsell.
    var observer = new MutationObserver(function (mutations) {
      // Only re-render if the change wasn't us inserting our own slots
      var ourChange = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n && n.id && (n.id === 'sp-ship-bar-slot' || n.id === 'sp-upsell-slot')) {
            ourChange = true; break;
          }
        }
      }
      if (!ourChange) render();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
  } else {
    install();
  }
})();
